import { Outlet } from "react-router-dom";
import useOrganization from "../hooks/useOrganization";
import NoAccess from "../pages/NoAccess/NoAccess";
import { canManageOrganization } from "./access";
import { useSession } from "./SessionContext";

const RequireOrganizationAccess: React.FC = () => {
  const { user } = useSession();
  const organization = useOrganization();
  return canManageOrganization(user, organization) ? <Outlet /> : <NoAccess />;
};

export default RequireOrganizationAccess;
